import { createAction, handleActions } from "redux-actions";

import { countries } from "../../config";
import Api, { Schemas, normalizeResponse } from "../../services/Api";

import { INTL_CITY_SET } from "../intl";
import { COUNTRIES_CLEAR, COUNTRY_SET, COUNTRIES_GET } from "./actionTypes";

//  Actions
export const clearCountriesAction = createAction(COUNTRIES_CLEAR);
export const setCountryAction = createAction(COUNTRY_SET);
const _getCountriesAction = createAction(COUNTRIES_GET.TYPE, (...args) =>
  Api.getPhoneCountries(...args)
);

export function getCountriesAction(query) {
  return (dispatch, getState) => {
    // TODO: check last query
    return dispatch(_getCountriesAction(query));
  };
}

//  Reducer
const norm = normalizeResponse(countries, [Schemas.country]);
const initialState = {
  entities: norm.entities.countries,
  result: norm.result,
  active: norm.result[0],
};

export default handleActions(
  {
    [COUNTRIES_CLEAR]: applyClearCountries,
    [COUNTRIES_GET.FULFILLED]: applyGetCountriesFullfilled,
    [COUNTRY_SET]: applySetCountry,
    [INTL_CITY_SET]: applyCity,
  },
  initialState
);

//  Action Reducers
function applyClearCountries(state, action) {
  return {
    ...state,
    result: initialState.result,
  };
}

function applyGetCountriesFullfilled(state, action) {
  const { entities, result } = action.payload;

  return {
    ...state,
    entities: { ...state.entities, ...entities.countries },
    result,
  };
}

function applySetCountry(state, action) {
  return {
    ...state,
    active: action.payload,
    result: initialState.result,
  };
}

function applyCity(state, { payload }) {
  const { countryId } = payload;

  return {
    ...state,
    active: countryId,
    result: initialState.result,
  };
}
